<section>
    <div class="row g-3">
        <div class="col-md-4">
            <form [formGroup]="fetchPODetailsForm" *ngIf="POList?.length">
                <label for="PoList" class="form-label text-small">PO Number</label>
                <select formControlName="PoList" class="form-control form-control-sm"
                    [error]="fetchPODetailsForm.get('PoList')">
                    <option [ngValue]="null" selected disabled>Select a PO</option>
                    <option *ngFor="let value of POList" [value]="value.po_number">{{value.display}}</option>
                </select>
                <form-feedback [formGroup]="fetchPODetailsForm" field="PoList"></form-feedback>
                <button type="button" class="btn btn-outline-primary m-2" [disabled]="!fetchPODetailsForm.valid"
                    (click)="fetchPoFlowGridData()">
                    Go
                </button>
            </form>
            <div class="d-flex mb-4 mt-1 justify-content-between" *ngIf="POList?.length > 0">
                <div class="d-flex mb-4 mt-1 justify-content-centre">
                    <div class="col-1-1">
                        <span class="dot" title="PO Created"
                            [ngStyle]="{'background-color':(rowData[0]?.po_status == 'CREATED') ? '#0098a6' : '#C2C2C2E6' }">
                        </span>
                        <span class="font-10">CREATED</span>
                    </div>
                    <span class="mb-2 pl-10" *ngIf="rowData[0]?.po_status == 'CREATED'"><strong>PO Created</strong></span><span class="mb-1">-</span>&nbsp;&nbsp;&nbsp;
                    <div class="col-1-1">
                        <span class="dot" title="PO YET TO RELEASE"
                            [ngStyle]="{'background-color':(rowData[0]?.po_status == 'PO YET TO RELEASE') ? '#0098a6' : '#C2C2C2E6' }"></span>&nbsp;
                        <span class="font-10">YET TO RELEASE</span>
                    </div>
                    <span class="mb-2 pl-10" *ngIf="rowData[0]?.po_status == 'PO YET TO RELEASE'"><strong>PO YET TO
                            RELEASE</strong></span><span class="mb-2">-</span>&nbsp;&nbsp;&nbsp;
                    <div class="col-1-1">
                        <span class="dot" title="PO RELEASED"
                            [ngStyle]="{'background-color':(rowData[0]?.po_status == 'PO IS RELEASED') ? '#00cc00' : '#C2C2C2E6' }"></span>&nbsp;
                        <span class="font-10">RELEASED</span>
                    </div>
                    <span class="mb-2 pl-10" *ngIf="rowData[0]?.po_status == 'PO IS RELEASED'"><strong>PO RELEASED</strong></span>
            
                    <!-- <span class="mb-2">-</span>&nbsp;&nbsp;&nbsp;
                    <div class="col-1-1">
                        <span class="dot" title="PO PDF COPY SEND"
                            [ngStyle]="{'background-color':(rowData[0]?.po_status == 'PO IS RELEASED'||rowData[0]?.po_status == 'WAITING FOR ACKNOWLEDGEMENT'||rowData[0]?.po_status == 'PO CONFIRMATION RECIEVED' || rowData[0]?.po_status == 'PO HISTORY FOUND') ? '#0098a6' : '#C2C2C2E6' }"></span>&nbsp;
                        <span class="font-10">PDF COPY SENT</span>
                    </div>
                    <span class="mb-2 col-3 pl-10" *ngIf="rowData[0]?.po_status == 'PO IS RELEASED'"><strong>PO PDF COPY SENT</strong></span> -->
            
                    <span class="mb-2">-</span>&nbsp;&nbsp;&nbsp;
                    <div class="col-12-1">
                        <span class="dot" title="WAITING FOR ACKNOWLEDGEMENT"
                            [ngStyle]="{'background-color':(rowData[0]?.po_status == 'WAITING FOR ACKNOWLEDGEMENT') ? '#0098a6' : '#C2C2C2E6' }"></span>&nbsp;
                        <span class="font-10">WAITING FOR ACKNOWLEDGEMENT</span>
                    </div>
                    <span class="mb-2 pl-10" *ngIf="rowData[0]?.po_status == 'WAITING FOR ACKNOWLEDGEMENT'"><strong>WAITING FOR ACKNOWLEDGEMENT</strong></span>
                    <span class="mb-2">-</span>&nbsp;&nbsp;&nbsp;
                    <div  class="col-12-1">
                        <span class="dot" title="PO CONFIRMATION RECIEVED"
                            [ngStyle]="{'background-color':rowData[0]?.po_status == 'PO CONFIRMATION RECIEVED' ? '#108548' : '#C2C2C2E6' }"></span>&nbsp;
                        <span class="font-10">PO CONFIRMATION RECIEVED</span>
                    </div>
                    <!-- <span class="mb-2 pl-10" *ngIf="rowData[0]?.po_status == 'PO CONFIRMATION RECIEVED'"><strong>PO CONFIRMATION RECIEVED</strong></span> -->
                    <span class="mb-2">-</span>&nbsp;&nbsp;&nbsp;
                    <div class="col-12-1">
                        <span class="dot" title="PO HISTORY FOUND"
                            [ngStyle]="{'background-color':rowData[0]?.po_status == 'PO HISTORY FOUND' ? '#d85405' : '#C2C2C2E6' }"></span>&nbsp;
                        <span class="font-10">PO HISTORY FOUND</span>
                    </div>
                    <span class="mb-2 pl-10" *ngIf="rowData[0]?.po_status == 'PO HISTORY FOUND'"><strong>PO HISTORY FOUND</strong></span>
                </div>
            </div>
        </div>
        <div class="col-md-8">
            <div class="d-flex mb-4 mt-1 justify-content-end">
                <button type="button" class="btn btn-outline-primary m-2" (click)="refreshPO()" *ngIf="POList?.length > 0">
                    <i class="fa fa-refresh" aria-hidden="true"></i>&nbsp;&nbsp;<span>Refresh</span>
                </button>
                <button type="button" class="btn btn-outline-primary m-2" (click)="openPOHistoryModal()" *ngIf="rowData[0]?.po_status == 'PO IS RELEASED' || rowData[0]?.po_status == 'PO HISTORY FOUND'|| rowData[0]?.po_status == 'PO DELIVERED' || rowData[0]?.po_status == 'WAITING FOR ACKNOWLEDGEMENT'|| rowData[0]?.po_status == 'GR QTY REVERSED'">
                    View PO History
                </button>
                <button type="button" class="btn btn-outline-primary m-2" (click)="openCreatePOModal()" *ngIf="qesData?.qes_status === 'QES_APPROVED' || prData[0].status === 'QES APPROVED'">
                    Create PO
                </button>
                <button type="button" class="btn btn-outline-primary m-2" (click)="downloadReport()" *ngIf="POList?.length && isNotVendor && fetchPODetailsForm.valid">
                    Download Report
                </button>
                <button type="button" class="btn btn-outline-primary m-2" (click)="openViewPOApproversModal()" *ngIf="POList?.length && isNotVendor && fetchPODetailsForm.valid">
                    View PO Approvers
                </button>
                <button type="button" class="btn btn-outline-primary m-2" (click)="viewQES()" *ngIf="qesData?.id && isNotVendor">
                    Go to QES
                </button>
                <button type="button" class="btn btn-outline-primary m-2" (click)="downloadPdf()" *ngIf="qesData?.id && isNotVendor && (qesData?.qes_status == 'QES_APPROVED' || qesData?.qes_status == 'QES_SUBMITTED')">
                    Download QES Report
                </button>
            </div>
        </div>

    </div>
    <div class="row mt-3">
        <app-ag-grid-wrapper rowSelection='single' (rowSelected)="OnRowSelected($event)"  #grid [gridConfig]='gridOptions' [rowData]="rowData" [columnDefs]="columnDefs"
            [frameworkComponents]='frameworkComponents' [context]='context' (gridReady)="onGridReady()">
        </app-ag-grid-wrapper>
    </div>
</section>